import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'

import { isNotEmpty } from "../../utilities/FrontFunctions/AoxFrontFunctions"
import IconSVG from "../../utilities/FrontFunctions/IconSVG"

import '../../assets/css/0020_objects/0600_obj_menu_thematique_aside.css'
import '../../assets/css/0020_objects/0740_obj_socials_formation_footer.css'


class SectionSocialsFormationFooter extends Component {
	render() {
        var ItemsSocial = [];

        var oFacebookUrl = this.props.sitecoreContext.route?.fields["Facebook Url"];
		var sFacebookUrl = (oFacebookUrl != null ) ? oFacebookUrl.value.href : "";
        if (isNotEmpty(sFacebookUrl)){
            ItemsSocial.push({ label: "Facebook", link: sFacebookUrl, class: "facebook" });
        }

		var oInstagramUrl = this.props.sitecoreContext.route?.fields["Instagram Url"];
		var sInstagramUrl = (oInstagramUrl != null ) ? oInstagramUrl.value.href : "";
        if (isNotEmpty(sInstagramUrl)){
            ItemsSocial.push({ label: "Instagram", link: sInstagramUrl, class: "instagram" });
        }

		var oYoutubeUrl = this.props.sitecoreContext.route?.fields["Youtube Url"];
		var sYoutubeUrl = (oYoutubeUrl != null ) ? oYoutubeUrl.value.href : "";
        if (isNotEmpty(sYoutubeUrl)){
            ItemsSocial.push({ label: "YouTube", link: sYoutubeUrl, class: "youtube" });
        }

		return (
			<>{ ItemsSocial.length > 0 && <>
                <section className="obj_section section_socials_formation_footer">
                    <div className="ctn_section">

                        <div className="obj_socials_formation_footer">
                            <div className="ctn_text">
                                <p className="t_title">{this.props.t('BrandSectionSocialNetworkTitle')}</p>
                            </div>
                            <ul className="obj_social_list">
                                { ItemsSocial.map((item, index) => (
                                    <li className={"item_social var_" + item.class} key={index}>
                                        <a href={item.link} title={item.label}>
                                            <IconSVG icon={item.class} />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </div>
                </section>
			</>}</>
		)
	}

}

export default withTranslation()(withSitecoreContext()(SectionSocialsFormationFooter));